import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';

export interface CaseProvider {
  providerId: string;
  providerName: string;
  providerType: string;
}

interface CaseProvidersState {
  caseProvidersList: CaseProvider[];
}

const initialState: CaseProvidersState = {
  caseProvidersList: []
};

const caseProvidersSlice = createSlice({
  name: 'caseProviders',
  initialState: initialState,
  reducers: {
    setCaseProvidersList: (state, action: PayloadAction<CaseProvider[]>) => {
      state.caseProvidersList = action.payload;
    }
  }
});

export const { setCaseProvidersList } = caseProvidersSlice.actions;

export const selectCaseProvidersList = (state: RootState) => {
  return state.caseProviders.caseProvidersList;
};

export const caseProvidersReducer = caseProvidersSlice.reducer;
